import React from "react";
import CardBasic from "../CardBasic";

export default function CardUser({
   i,
   data,
   enActionEdit,
   enActionDelete,
   editFunction,
   deleteFunction,
   isDisable,
}) {
   return (
      <CardBasic
         key={data.akuisisi_id}
         i={data.akuisisi_id}
         title={data.user_name}
         isDisable={isDisable}
         enActionDelete={enActionDelete}
         enActionEdit={enActionEdit}
         editFunction={editFunction}
         deleteFunction={deleteFunction}
         data={data}
      >
         <div className="px-5 py-4">
            <div className="space-y-3">
               <div className="flex items-center">
                  <div className="w-full flex items-center text-sm">
                     <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-[#ED64BD]"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                     >
                        <path
                           strokeLinecap="round"
                           strokeLinejoin="round"
                           strokeWidth={2}
                           d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                        />
                     </svg>
                     <p className="ml-2 text-gray-500">+{data.user_mobile}</p>
                  </div>
                  <div className="w-full flex items-center text-sm">
                     <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 text-[#ED64BD]"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                     >
                        <path
                           strokeLinecap="round"
                           strokeLinejoin="round"
                           strokeWidth={2}
                           d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                        />
                     </svg>
                     <p className="ml-2 text-gray-500">{data.user_email}</p>
                  </div>
               </div>
               <div className="flex items-center">
                  <div className="w-full flex items-center text-sm">
                     <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="h-4 w-4 text-[#ED64BD]"
                     >
                        <path
                           strokeLinecap="round"
                           strokeLinejoin="round"
                           d="M13.5 21v-7.5a.75.75 0 01.75-.75h3a.75.75 0 01.75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349m-16.5 11.65V9.35m0 0a3.001 3.001 0 003.75-.615A2.993 2.993 0 009.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 002.25 1.016c.896 0 1.7-.393 2.25-1.016a3.001 3.001 0 003.75.614m-16.5 0a3.004 3.004 0 01-.621-4.72L4.318 3.44A1.5 1.5 0 015.378 3h13.243a1.5 1.5 0 011.06.44l1.19 1.189a3 3 0 01-.621 4.72m-13.5 8.65h3.75a.75.75 0 00.75-.75V13.5a.75.75 0 00-.75-.75H6.75a.75.75 0 00-.75.75v3.75c0 .415.336.75.75.75z"
                        />
                     </svg>
                     <p className="ml-2 text-gray-500">
                        {data.outlet_kartini_name}
                     </p>
                  </div>
                  <div className="w-full flex items-center text-sm">
                     <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="h-4 w-4 text-[#ED64BD]"
                     >
                        <path
                           strokeLinecap="round"
                           strokeLinejoin="round"
                           d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                        />
                     </svg>
                     <p className="ml-2 text-gray-500">
                        {data.user_type ?? "-"}
                     </p>
                  </div>
               </div>
            </div>
         </div>
      </CardBasic>
   );
}
